export default __webpack_public_path__ + "static/media/phone_24.eb9525e9.svg";